import { createStore } from "vuex";

import tagsModule from "./modules/tags/index.js";
import languagesModule from "./modules/languages/index.js";
import quotesModule from "./modules/quotes/index.js";
import preventiviModule from "./modules/preventivi/index.js";
import clientsModule from "./modules/clients/index.js";
import mailingListsModule from "./modules/mailingLists/index.js";
import structureModule from "./modules/structures/index.js";
import authModule from "./modules/auth/index.js";
import settingsModule from "./modules/settings/index";
import mailModule from "./modules/mail/index";
import campaigns from "./modules/campaigns/index";
import dashboard from "./modules/dashboard/index";
import notifications from "./modules/notifications/index";
import updates from "./modules/updates/index";

const store = createStore({
  modules: {
    tags: tagsModule,
    languages: languagesModule,
    quotes: quotesModule,
    clients: clientsModule,
    structures: structureModule,
    preventivi: preventiviModule,
    lists: mailingListsModule,
    auth: authModule,
    settings: settingsModule,
    mail: mailModule,
    campaigns: campaigns,
    dashboard: dashboard,
    notifications: notifications,
    updates: updates,
  },
});

export default store;
